import {
  Box,
  ContentBlock,
  Stack,
} from 'braid-design-system';
import type React from 'react';

import Footer from './Footer/Footer';
import Header from './Header/Header';


interface Props {
  children: React.ReactNode;
}

const MainLayout = ({ children }: Props) => {

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent= 'spaceBetween'
      style={{
        minHeight: '100vh',
        minWidth: '100vh',
      }}
    >

      <Stack space={['none', 'medium', 'medium']}>
        <Header />
      </Stack>

      <Box paddingBottom={['none', 'xlarge', 'xxlarge']}>
        <Stack space={['none', 'medium', 'medium']}>
          <ContentBlock width="small">
            { children }
          </ContentBlock>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default MainLayout;
